(function () {
  'use strict';
  function init(selectors) {
    if (selectors.dataset.sizeLinksReady) return;
    selectors.dataset.sizeLinksReady = 'true';
    function align() {
      var size = selectors.querySelector('.product-swatch--size');
      if (!size) size = Array.from(selectors.querySelectorAll('.product-option-selector')).find(function (option) {
        var title = option.querySelector('.product-heading');
        return title && /size/i.test(title.textContent);
      });
      if (!size) return;
      var heading = size.querySelector('.product-heading');
      if (!heading) return;
      var row = size.querySelector('.product-size-heading');
      if (!row) {
        row = document.createElement('div');
        row.className = 'product-size-heading';
        heading.before(row);
        row.appendChild(heading);
        var links = document.createElement('div');
        links.className = 'product-size-links';
        row.appendChild(links);
      }
      var target = row.querySelector('.product-size-links');
      selectors.querySelectorAll('.ks-chart-container, .ks-calculator-container, .product-sizing').forEach(function (control) {
        if (control.parentElement !== target) target.appendChild(control);
      });
    }
    align();
    // Kiwi inserts its controls asynchronously and can replace them after a style change.
    new MutationObserver(align).observe(selectors, {childList:true, subtree:true});
  }
  function scan() { document.querySelectorAll('.product-selectors').forEach(init); }
  scan();
  document.addEventListener('shopify:section:load', scan);
}());
